module.exports = __webpack_public_path__ + "img/m-banner-kfkmkuef-id-ID.ac2f9e51.png";